<template>
  <v-container fluid>
    <div class="d-flex flex-column employee-card-path-to-readiness">
      <EmployeePageHeader
        v-if="isNewLayoutEnabled"
        :employeeData="employeeData"
        :loading="loading"
        @employee-updated="handleEmployeeUpdate"
        @refresh-employee-data="handleRefreshEmployeeData"
        @recalc-readiness="onEmployeeReadiness"
      />
      <div>
        <NoRecordFound
          v-if="chatterData.length === 0"
          title="Employee Chatter"
          message="Employee Chatter"
          btnTitle=""
          class="chatter-not-found"
        />
        <ActivityStream
          class="mx-4"
          :dataStream="chatterData"
          :show-load-more-button="totalChatterData > chatterData.length"
          @onLoadMore="getEmployeesChatter"
          :dynamicOffset="85"
        />
      </div>
    </div>
  </v-container>
</template>
<script>
import ActivityStream from "@components/Chatter/ActivityStream.vue";
import { getEmployeeChatter } from "@/api";
import { transformChatterData } from "@/utils/chatterUtils";
import NoRecordFound from "@components/NoRecordFound/NoRecordFound.vue";
import EmployeePageHeader from "@components/common/EmployeePageHeader.vue";

export default {
  name: "EmployeeChatterView",
  components: {
    ActivityStream,
    NoRecordFound,
    EmployeePageHeader,
  },
  data() {
    return {
      chatterData: [],
      totalChatterData: [],
      accountID: "",
      employeeData: null,
      loading: {
        readinessBar: false,
      },
    };
  },
  computed: {
    isNewLayoutEnabled() {
      return this.$store.getters["featureFlags/isNewDesign"];
    },
  },
  watch: {
    "$route.params.id": {
      handler(newId, oldId) {
        if (newId && newId !== oldId) {
          this.$nextTick(() => {
            this.handleRefreshEmployeeData();
          });
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    this.accountID = JSON.parse(localStorage.getItem("currentAccountID"));
    this.$loader.show();
    await this.getEmployeeData();
    await this.getEmployeesChatter();
    this.$loader.hide();
  },
  methods: {
    async getEmployeeData() {
      try {
        // Get employee data from store (should be loaded by sidebar)
        const employeeData =
          this.$store.getters["employeeStore/currentEmployee"];
        if (employeeData) {
          this.employeeData = employeeData;
        }
      } catch (e) {
        console.error("Failed to load employee data", e);
      }
    },
    async handleRefreshEmployeeData() {
      await this.getEmployeeData();
    },
    async getEmployeesChatter() {
      const empId = this.$route.params.id;
      const page = Math.ceil(this.chatterData.length / 10);
      this.$loader.show();
      const { data } = await getEmployeeChatter(
        this.accountID,
        empId,
        page + 1
      );
      if (data && data.count) {
        this.totalChatterData = data.count;
      }
      if (data && data.results) {
        const chatterItems = transformChatterData(data.results);
        this.chatterData.push(...chatterItems);
      }
      this.$loader.hide();
    },
    handleEmployeeUpdate() {
      this.employeeData = this.$store.getters["employeeStore/currentEmployee"];
    },
    async onEmployeeReadiness() {
      // Readiness calculation is now handled by the sidebar component
      // Employee data will be updated automatically in the store
      const empId = this.$route.params.id;
      if (empId) {
        // Emit event to sidebar to trigger readiness recalculation
        this.$parent.$refs?.employeeSideBar?.recalculateEmployeeReadiness(
          empId
        );

        // Update local employee data from store
        this.employeeData =
          this.$store.getters["employeeStore/currentEmployee"];
      }
    },
  },
};
</script>
<style>
.custom-chatter-view {
  margin-top: -35px;
}
.chatter-not-found .badge {
  display: none;
}
.chatter-not-found button {
  display: none;
}
</style>
